import React, { useCallback } from 'react';

import Button from '../../../../elements/Button/Button';
import ContainedImage from '../../../../elements/ContainedImage';
import Link from '../../../../elements/Link';
import styles from './SpeakersMosaic.module.scss';

const SpeakerCard = props => {
    const {i18n, event, speaker} = props;

    const handleMakeAppointment = useCallback(
        e => {
            e.preventDefault();
            e.stopPropagation();

            const link = `./invite?speakers=${speaker.id}`;
            app.history.push(link);
        },
        [speaker]
    );

    // console.log('SPEAKER', speaker);

    return (
        <Link className={styles.SpeakerCard} href={`./speakers/${speaker.id}`}>
            <ContainedImage className="avatar" src={speaker.photo_url} altSrc="/img/no_avatar.png" />
            {speaker.name ? <p className={styles.name}>{speaker.name}</p> : null}
            {speaker.position ? <p className={styles.position}>{speaker.position}</p> : null}
            {speaker.company ? <p className={styles.company}>{speaker.company}</p> : null}
            {speaker.extra ? <p className={styles.extra}>{speaker.extra}</p> : null}
            <hr />
            <Button className={styles.appointment} style={event._local.styles.button} onClick={handleMakeAppointment}>
                {i18n['label.send.invitation']}
            </Button>
        </Link>
    );
};

export default SpeakerCard;
